import React from "react";

const HorizontalDivider = ({ className }: { className?: string }) => {
  return (
    <div className={`horizontal-divider ${className || ""}`}></div>
  );
};

export default HorizontalDivider;
